<td-wb-notification notificationType="info">
  <td-wb-icon tdWbNotificationIcon
              iconId="pie-chart"
              size="24" />
  <span [innerHTML]="'tdWb.accounts.assetAllocations.multiAssetFund.expandNotification.BODY' | tdWbTranslate"></span>
</td-wb-notification>
